var _rect, _rect2, _rect3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiAssistantCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 77,
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_23319_42634)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    width: 60,
    height: 60,
    rx: 30,
    fill: "url(#paint0_linear_23319_42634)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.0714,
    y: 1.07143,
    width: 57.8571,
    height: 57.8571,
    rx: 28.9286,
    stroke: "white",
    strokeWidth: 2.14286
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23319_42634",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 14,
    width: 32,
    height: 32
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 14,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23319_42634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.0001 31.8667L32.4667 38.4001C32.2223 38.6445 31.9112 38.7667 31.5334 38.7667C31.1556 38.7667 30.8445 38.6445 30.6001 38.4001C30.3556 38.1556 30.2334 37.8445 30.2334 37.4667C30.2334 37.089 30.3556 36.7778 30.6001 36.5334L37.1334 30.0001L30.6001 23.4667C30.3556 23.2223 30.2334 22.9112 30.2334 22.5334C30.2334 22.1556 30.3556 21.8445 30.6001 21.6001C30.8445 21.3556 31.1556 21.2334 31.5334 21.2334C31.9112 21.2334 32.2223 21.3556 32.4667 21.6001L39.0001 28.1334L45.5334 21.6001C45.7778 21.3556 46.089 21.2334 46.4667 21.2334C46.8445 21.2334 47.1556 21.3556 47.4001 21.6001C47.6445 21.8445 47.7667 22.1556 47.7667 22.5334C47.7667 22.9112 47.6445 23.2223 47.4001 23.4667L40.8667 30.0001L47.4001 36.5334C47.6445 36.7778 47.7667 37.089 47.7667 37.4667C47.7667 37.8445 47.6445 38.1556 47.4001 38.4001C47.1556 38.6445 46.8445 38.7667 46.4667 38.7667C46.089 38.7667 45.7778 38.6445 45.5334 38.4001L39.0001 31.8667Z",
    fill: "#587E85"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_23319_42634",
    x: 9.53674e-7,
    y: 0,
    width: 78,
    height: 78,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_23319_42634"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_23319_42634",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23319_42634",
    x1: 9,
    y1: 0,
    x2: 69,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8ED5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9CF3D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAssistantCloseIcon);
export default __webpack_public_path__ + "static/media/ai_assistant_close_icon.42f833fe49bc5d90cbab06bc88fb8ac0.svg";
export { ForwardRef as ReactComponent };